/* @jsxImportSource @emotion/react */

import React from 'react'
import classNames from 'classnames'
import { FormattedMessage } from 'react-intl'

import { useRoutes } from '../../routes'

export const SliteRatings = ({ className }: { className?: string }) => {
  const routes = useRoutes()
  const SOCIAL_PROOFS = [
    {
      rating: '4,7/5',
      source: 'G2 Crowd',
      href: routes.external.g2.url,
    },
    {
      rating: '4,7/5',
      source: 'Capterra',
      href: routes.external.capterra.url,
    },
    {
      rating: '4,9/5',
      source: 'ProductHunt',
      href: routes.external.productHunt.url,
    },
  ]
  return (
    <div
      className={classNames(
        'flexbox flexbox-wrap flexbox-align-center flexbox-gap-20',
        className
      )}
    >
      {SOCIAL_PROOFS.map((proof, index) => (
        <a
          key={index}
          className="shade-05 pointer-on-hover transition font-size-8 pointer line-height-larger"
          href={proof.href}
          target="_blank"
          rel="noreferrer"
        >
          <span className="font-weight-bold">{proof.rating}</span>
          <br />
          <span className="no-break-word font-weight-regular">
            <FormattedMessage
              id="footer.onXPlatform"
              defaultMessage="on {source}"
              values={{
                source: proof.source,
              }}
            />
          </span>
        </a>
      ))}
    </div>
  )
}
